import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

// Get connection string from environment variables
// In Azure, this will be set from Key Vault
// When a connection string is set in Azure App Service with name INSIGHTS_CONNECTION_STRING,
// it becomes available as CUSTOMCONNSTR_INSIGHTS_CONNECTION_STRING
const connectionString = import.meta.env.CUSTOMCONNSTR_INSIGHTS_CONNECTION_STRING;

const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
        },
        maxBatchInterval: 500,
        disableFetchTracking: false,
        enableAjaxErrorStatusText: true,
        enableAjaxPerfTracking: true
    }
});

// Only initialize if connection string is available
if (connectionString) {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
}

export { reactPlugin, appInsights };

// Custom hook for component tracking
export const getAppInsights = () => appInsights; 